<template>
  <div class="fifa2026-page">

    <!-- ① Hero 主視覺 -->
    <header id="hero">
      <img :src="img('head-bg.png')" alt="" class="hero-bg" aria-hidden="true">
      <div class="hero-inner">
        <img :src="img('mt-logo.png')" alt="MT" class="hero-logo">
        <img :src="img('head-h1.png')" alt="世界盃冠軍競猜" class="hero-h1">
        <img :src="img('head-h2.png')" alt="瓜分百萬彩池！" class="hero-h2">
        <img :src="img('head-instruction.png')" alt="單日投注滿 NT$1,000 起即可獲得冠軍競猜門票" class="hero-instruction">
        <img :src="img('head-total-money.png')" alt="總彩池 NT$1,000,000" class="hero-total-money">
      </div>
    </header>

    <!-- ② 主題標語 -->
    <section id="theme-banner" class="placeholder-section">
      <img :src="img('theme-banner-title.png')" alt="世界盃冠軍你看好誰？" class="section-title-img">
    </section>

    <!-- ③ 活動參與流程 -->
    <section id="how-to-join" class="placeholder-section">
      <div class="section-title-bar">
        <img :src="img('how-to-join-title.png')" alt="活動參與流程" class="section-title-img">
      </div>
      <div class="htj-steps">
        <div v-for="(step, index) in howToJoinSteps" :key="'step-wrap-' + step.id" class="htj-step-group">
          <div class="htj-step">
            <img :src="img(step.icon)" :alt="'STEP ' + step.id" class="htj-step-icon">
            <img :src="img(step.titleImg)" :alt="step.titleAlt" class="htj-step-title">
          </div>
          <img
            v-if="index < howToJoinSteps.length - 1"
            :src="img('how-to-join-arrow.png')"
            alt=""
            class="htj-arrow"
            aria-hidden="true"
          >
        </div>
      </div>
      <div class="htj-descs">
        <div class="htj-desc">
          滿額 NT$1,000<br>
          即可獲得門票資格
        </div>
        <img :src="img('how-to-join-line.png')" alt="" class="htj-line-divider" aria-hidden="true">
        <div class="htj-desc">
          每日最多 1 張<br>
          活動期間最多 3 張<br>
          請至下方"門票領取"處點擊領取
        </div>
        <img :src="img('how-to-join-line.png')" alt="" class="htj-line-divider" aria-hidden="true">
        <div class="htj-desc">
          投注後 7 天內領取<br>
          十六強開賽前完成預測
        </div>
        <img :src="img('how-to-join-line.png')" alt="" class="htj-line-divider" aria-hidden="true">
        <div class="htj-desc">
          猜中冠軍即可與<br>
          <strong class="htj-desc-gold">中獎者均分百萬獎池！</strong>
        </div>
      </div>
    </section>

    <!-- ④ 活動時間 -->
    <section id="event-period" class="placeholder-section">
      <div class="section-title-bar">
        <img :src="img('event-period-title.png')" alt="預測時間" class="section-title-img">
      </div>
      <div class="ep-content">
        <p class="ep-line1">
          <span class="ep-line2">2026/06/08 16:00:00⾄</span><strong class="ep-line2">2026/07/04 23:59:59 </strong>
        </p>
        <p class="ep-line2">MT體育競猜活動將於 7/23 12:00關閉活動頁面</p>
      </div>
    </section>

    <!-- ⑤ 門票領取 -->
    <section id="ticket-claim" class="placeholder-section">
      <div class="section-title-bar">
        <img :src="img('ticket-claim-title.png')" alt="門票領取" class="section-title-img">
      </div>
      <div class="tc-content">
        <p v-if="showTicketSummary" class="tc-row">
          <strong>會員帳號：</strong><strong>{{ memberAccount }}</strong>
        </p>
        <p v-if="showTicketSummary" class="tc-row">
          <strong>已領取門票：</strong><strong>{{ ticketsClaimed }}</strong>
          <span class="tc-gap"></span>
          <strong>已使用門票：</strong><strong>{{ ticketsUsed }}</strong>
        </p>
        <button
          class="tc-btn"
          :class="{ 'tc-btn--disabled': isClaimingTicket }"
          type="button"
          :disabled="isClaimingTicket"
          :aria-busy="isClaimingTicket ? 'true' : 'false'"
          @click="onClaimTicket"
        >
          <img :src="img('ticket-claim-button.png')" alt="領票">
        </button>
      </div>
    </section>

    <!-- ⑥ 投注紀錄 -->
    <section id="bet-records" class="placeholder-section">
      <div class="section-title-bar">
        <img :src="img('bet-records-title.png')" alt="投注紀錄" class="section-title-img">
      </div>
      <div class="br-list">
        <div v-for="record in betRecords" :key="record.id" class="br-item">
          <img :src="img(record.numImg)" :alt="String(record.id)" class="br-num">
          <div class="br-card">
            <img :src="img(record.cardBg)" alt="" class="br-card-bg" aria-hidden="true">
            <div class="br-flag-wrap">
              <img :src="resolveBetRecordFlag(record.flagImg)" :alt="record.flagAlt" class="br-flag">
              <span class="br-flag-label">{{ record.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ⑦ 使用門票開始預測 -->
    <section id="start-prediction" class="placeholder-section">
      <div class="section-title-bar">
        <img :src="img('start-prediction-title.png')" alt="使用門票開始預測" class="section-title-img">
      </div>
      <div class="sp-content">
        <div class="sp-slider-section">
          <div class="sp-slider-wrapper">
            <button class="sp-arrow sp-arrow--left" id="sp-prev" type="button" aria-label="上一頁">
              <img :src="img('page_arrow_left.png')" alt="上一頁">
            </button>
            <div class="sp-slider-viewport">
              <div class="sp-slider-track" id="sp-slider-track"></div>
            </div>
            <button class="sp-arrow sp-arrow--right" id="sp-next" type="button" aria-label="下一頁">
              <img :src="img('page_arrow_right.png')" alt="下一頁">
            </button>
          </div>
          <div class="sp-indicators" id="sp-indicators"></div>
        </div>
        <!-- <img :src="img('start-prediction-icon.png')" alt="冠軍預測轉盤" class="sp-icon"> -->
        <button
          class="sp-btn"
          type="button"
          :class="{ 'sp-btn--disabled': isSubmittingPrediction }"
          :disabled="isSubmittingPrediction"
          @click="onConfirmSelection"
        >
          <img :src="img('button_confirm_selected.png')" alt="確認選擇">
        </button>
      </div>
    </section>
    <!-- 彩池公式顯示區 -->
    <div class="sp-prizepool">
      <div class="sp-prizepool-col">
        <span class="sp-prizepool-label">總彩池</span>
        <span class="sp-prizepool-value">{{ prizePoolTotalText }}</span>
      </div>
      <div class="sp-prizepool-divider"></div>
      <div class="sp-prizepool-col">
        <span class="sp-prizepool-label sp-prizepool-label--participants">
          <template v-if="selectedSliderTeamId">
            <span class="sp-prizepool-team-name">{{ getTeamNameById(selectedSliderTeamId) }}</span><span class="sp-prizepool-label-suffix">參與人數</span>
          </template>
          <template v-else>參與人數</template>
        </span>
        <span class="sp-prizepool-value">{{ participantCountText }}</span>
      </div>
      <div class="sp-prizepool-divider"></div>
      <div class="sp-prizepool-col">
        <span class="sp-prizepool-label">預估每人可分</span>
        <span class="sp-prizepool-value sp-prizepool-value--highlight">{{ perPersonAmountText }}</span>
      </div>
    </div>

    <!-- Footer -->
    <footer id="site-footer">
      <!-- <div class="footer-logos">
        <img
          v-for="n in 6"
          :key="n"
          :src="img('foot-logo-' + n + '.png')"
          :alt="'合作夥伴 ' + n"
          class="footer-logo"
        >
      </div> -->
    </footer>

    <!-- Popup：訊息提示 -->
    <div
      id="ticket-message-overlay"
      class="popup-overlay"
      :class="{ 'is-open': ticketMessageOpen }"
      role="dialog"
      aria-modal="true"
      aria-labelledby="ticket-message-title"
      @click.self="closeTicketMessage"
    >
      <div class="popup-dialog">
        <header class="popup-header">
          <h2 id="ticket-message-title" class="popup-title">提示</h2>
          <button class="popup-close" type="button" aria-label="關閉" @click="closeTicketMessage">✕</button>
        </header>
        <div class="popup-body">
          <img :src="img('dialog-icon.png')" alt="" class="popup-icon" aria-hidden="true">
          <p class="popup-label ticket-message-text">{{ ticketMessageText }}</p>
        </div>
        <footer class="popup-footer">
          <button class="popup-btn popup-btn--confirm popup-btn--single" type="button" @click="closeTicketMessage">
            <img :src="img('dialog-claim-button-confirm.png')" alt="確認">
          </button>
        </footer>
      </div>
    </div>

  </div>
</template>

<script>
const imageContext = require.context('@/assets/fifa2026/images', false, /\.png$/)
const flagRectBigContext = require.context('@/assets/fifa2026/images/flag_rect_big', false, /\.png$/)
const flagIconContext = require.context('@/assets/fifa2026/flag_icons', false, /\.png$/)

export default {
  name: 'Fifa2026',

  data () {
    return {
      ticketMessageOpen: false,
      ticketMessageText: '',
      memberToken: '',
      teamList: [],
      selectedSliderTeamId: null,
      prizePoolTotal: 1000000,
      prizePoolTotalText: 'NT$1,000,000',
      participantCountText: '0人',
      perPersonAmountText: '0',
      teamPredictionCounts: {},
      memberAccount: 'a123456',
      ticketsClaimed: 0,
      ticketsUsed: 0,
      showTicketSummary: false,
      isClaimingTicket: false,
      isSubmittingPrediction: false,
      ticketsPending: 3,
      howToJoinSteps: [
        { id: 1, icon: 'how-to-join-step-1.png', titleImg: 'how-to-join-step-1-title.png', titleAlt: '下注 MT 體育' },
        { id: 2, icon: 'how-to-join-step-2.png', titleImg: 'how-to-join-step-2-title.png', titleAlt: '獲得競猜門票' },
        { id: 3, icon: 'how-to-join-step-3.png', titleImg: 'how-to-join-step-3-title.png', titleAlt: '預測世界盃冠軍' },
        { id: 4, icon: 'how-to-join-step-4.png', titleImg: 'how-to-join-step-4-title.png', titleAlt: '猜中均分彩池' }
      ],
      betRecords: [
        { id: 1, numImg: 'bet-records-1-num.png', cardBg: 'bet-records-1.png', flagImg: 'bet-records-flag-unknown.png', flagAlt: '?', label: '未投注' },
        { id: 2, numImg: 'bet-records-2-num.png', cardBg: 'bet-records-2.png', flagImg: 'bet-records-flag-unknown.png', flagAlt: '?', label: '未投注' },
        { id: 3, numImg: 'bet-records-3-num.png', cardBg: 'bet-records-3.png', flagImg: 'bet-records-flag-unknown.png', flagAlt: '?', label: '未投注' }
      ]
    }
  },

  async mounted () {
    this.checkUserToken(this.$route.query.token)
    await this.fetchTeamList()
    await this.fetchTeamPredictionCount()
    this.initFlagSlider()
    this.fetchPredictRecords()
  },

  methods: {
    img (filename) {
      return imageContext('./' + filename)
    },
    imgFlagRectBig (flagNum) {
      try {
        return flagRectBigContext(`./${flagNum}.png`)
      } catch (err) {
        return this.img('bet-records-flag-unknown.png')
      }
    },
    getTeamById (teamId) {
      return this.teamList.find(t => t.id === teamId || t.id === Number(teamId)) || null
    },
    getTeamNameById (teamId) {
      const team = this.getTeamById(teamId)
      return team ? team.name : String(teamId)
    },
    isTeamDisused (teamId) {
      const team = this.getTeamById(teamId)
      if (!team) return false
      return String(team.disuse) === '1'
    },
    escapeHtml (text) {
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
    },
    initFlagSlider () {
      const teams = this.teamList
      const TOTAL_FLAGS = teams.length || 48
      const PER_PAGE = 12
      const TOTAL_PAGES = Math.ceil(TOTAL_FLAGS / PER_PAGE)

      const track = document.getElementById('sp-slider-track')
      const indicatorsEl = document.getElementById('sp-indicators')
      const prevBtn = document.getElementById('sp-prev')
      const nextBtn = document.getElementById('sp-next')
      if (!track || !indicatorsEl || !prevBtn || !nextBtn) return

      track.innerHTML = ''
      indicatorsEl.innerHTML = ''

      const frameIdle = this.img('flag-frame-idle.png')
      const frameSelected = this.img('flag-frame-selected-up.png')
      let currentPage = 0

      for (let p = 0; p < TOTAL_PAGES; p++) {
        const page = document.createElement('div')
        page.className = 'sp-page'
        const grid = document.createElement('div')
        grid.className = 'sp-grid'

        for (let i = 0; i < PER_PAGE; i++) {
          const teamIndex = p * PER_PAGE + i
          if (teamIndex >= TOTAL_FLAGS) break
          const team = teams[teamIndex]
          const flagNum = team.id
          const teamName = team.name || this.getTeamNameById(flagNum)
          const safeTeamName = this.escapeHtml(teamName)
          const isDisused = this.isTeamDisused(flagNum)
          const predictionCount = this.getTeamPredictionCount(flagNum)
          const countText = `票數 ${predictionCount} 人`
          const countClass = isDisused ? 'sp-flag-count sp-flag-count--disused' : 'sp-flag-count'
          const item = document.createElement('div')
          item.className = 'sp-flag-item' + (isDisused ? ' is-disused' : '')
          item.dataset.flag = flagNum
          item.innerHTML = `
          <div class="sp-flag-card">
            <img src="${frameIdle}" class="sp-frame" alt="">
            <img src="${this.imgFlagRectBig(flagNum)}" class="sp-flag-img" alt="${safeTeamName}">
            <img src="${frameSelected}" class="sp-frame-overlay" alt="">
            <div class="sp-flag-info">
              <span class="sp-flag-name">${safeTeamName}</span>
              <span class="${countClass}" data-flag="${flagNum}">${countText}</span>
            </div>
          </div>
        `
          item.addEventListener('click', () => {
            if (this.isTeamDisused(flagNum)) {
              this.showTicketMessage('該國家隊已淘汰，無法選擇')
              return
            }
            if (this.selectedSliderTeamId !== null) {
              const prev = document.querySelector(`.sp-flag-item[data-flag="${this.selectedSliderTeamId}"]`)
              if (prev) prev.classList.remove('is-selected')
            }
            item.classList.add('is-selected')
            this.selectedSliderTeamId = flagNum
            this.updatePrizePoolByTeam(flagNum)
          })
          grid.appendChild(item)
        }
        page.appendChild(grid)
        track.appendChild(page)
      }

      for (let p = 0; p < TOTAL_PAGES; p++) {
        const dot = document.createElement('span')
        dot.className = 'sp-dot' + (p === 0 ? ' sp-dot--active' : '')
        indicatorsEl.appendChild(dot)
      }

      const updateSlider = () => {
        track.style.transform = `translateX(-${currentPage * 100}%)`
        prevBtn.style.visibility = currentPage === 0 ? 'hidden' : 'visible'
        nextBtn.style.visibility = currentPage === TOTAL_PAGES - 1 ? 'hidden' : 'visible'
        document.querySelectorAll('.sp-dot').forEach((dot, i) => {
          dot.classList.toggle('sp-dot--active', i === currentPage)
        })
      }

      prevBtn.addEventListener('click', () => {
        if (currentPage > 0) {
          currentPage--
          updateSlider()
        }
      })
      nextBtn.addEventListener('click', () => {
        if (currentPage < TOTAL_PAGES - 1) {
          currentPage++
          updateSlider()
        }
      })

      updateSlider()

      // 預設選中第一個尚未淘汰的隊伍
      const firstAvailable = teams.find(t => !this.isTeamDisused(t.id))
      if (firstAvailable) {
        const firstItem = track.querySelector(`.sp-flag-item[data-flag="${firstAvailable.id}"]`)
        if (firstItem) {
          firstItem.classList.add('is-selected')
          this.selectedSliderTeamId = firstAvailable.id
          this.updatePrizePoolByTeam(firstAvailable.id)
        }
      }
    },
    updateFlagSliderCounts () {
      document.querySelectorAll('.sp-flag-count').forEach(el => {
        const flagNum = Number(el.dataset.flag)
        const count = this.getTeamPredictionCount(flagNum)
        el.textContent = `票數 ${count} 人`
      })
    },
    resolveBetRecordFlag (flagImg) {
      if (!flagImg) return this.img('bet-records-flag-unknown.png')
      if (
        flagImg.startsWith('data:') ||
        flagImg.startsWith('http://') ||
        flagImg.startsWith('https://') ||
        flagImg.startsWith('blob:')
      ) {
        return flagImg
      }
      if (/^\d+\.png$/.test(flagImg)) {
        try {
          return flagIconContext(`./${flagImg}`)
        } catch (err) {
          return this.img('bet-records-flag-unknown.png')
        }
      }
      return this.img(flagImg)
    },
    closeTicketMessage () {
      this.ticketMessageOpen = false
    },
    checkUserToken (token) {
      this.memberToken = token || ''
    },
    async fetchTeamPredictionCount () {
      try {
        const res = await fetch('/api/fifaTeamPredictionCount').then(r => r.json())
        if (res && (res.code === '0' || res.code === 0) && res.data) {
          this.teamPredictionCounts = res.data
        }
      } catch (err) {
        console.error('fetchTeamPredictionCount failed', err)
        this.teamPredictionCounts = {}
      }
    },
    getTeamPredictionCount (teamId) {
      if (teamId == null) return null
      const key = String(teamId)
      if (Object.prototype.hasOwnProperty.call(this.teamPredictionCounts, key)) {
        return Number(this.teamPredictionCounts[key]) || 0
      }
      if (Object.prototype.hasOwnProperty.call(this.teamPredictionCounts, teamId)) {
        return Number(this.teamPredictionCounts[teamId]) || 0
      }
      return 0
    },
    updatePrizePoolByTeam (teamId) {
      if (!teamId) {
        this.participantCountText = '0人'
        this.perPersonAmountText = '0'
        return
      }
      const count = this.getTeamPredictionCount(teamId)
      this.participantCountText = `${count}人`
      if (count > 0) {
        const perPerson = Math.floor(this.prizePoolTotal / count)
        this.perPersonAmountText = `NT$${perPerson.toLocaleString()}`
      } else {
        this.perPersonAmountText = '0'
      }
    },
    async fetchTeamList () {
      try {
        const res = await fetch('/api/fifaTeamList').then(r => r.json())
        if (res.code === '0' || res.code === 0) {
          this.teamList = Array.isArray(res.data) ? res.data : []
        } else if (Array.isArray(res)) {
          this.teamList = res
        } else if (Array.isArray(res.data)) {
          this.teamList = res.data
        }
      } catch (err) {
        console.error('fetchTeamList failed', err)
        this.teamList = []
      }
    },
    buildDefaultBetRecords (slotCount = 3) {
      return Array.from({ length: slotCount }, (_, index) => {
        const id = index + 1
        return {
          id,
          numImg: `bet-records-${id}-num.png`,
          cardBg: `bet-records-${id}.png`,
          flagImg: 'bet-records-flag-unknown.png',
          flagAlt: '?',
          label: '未投注'
        }
      })
    },
    async fetchPredictRecords () {
      const defaultRecords = this.buildDefaultBetRecords(3)
      if (!this.memberToken) {
        this.betRecords = defaultRecords
        return
      }
      try {
        const res = await fetch('/api/fifaPredict/list', {
          method: 'POST',
          body: JSON.stringify({ token: this.memberToken })
        }).then(r => r.json())
        if (!res || (res.code !== '0' && res.code !== 0) || !res.data) {
          this.betRecords = defaultRecords
          return
        }
        const { predictions = [] } = res.data
        const slotCount = Math.max(3, predictions.length)
        this.betRecords = this.buildDefaultBetRecords(slotCount).map((record, index) => {
          const prediction = predictions[index]
          if (!prediction) return record
          const teamLabel = prediction.name || prediction.enName || '已投注'
          return {
            ...record,
            flagImg: prediction.teamId ? `${prediction.teamId}.png` : 'bet-records-flag-unknown.png',
            label: prediction.name,
            flagAlt: teamLabel
          }
        })
      } catch (err) {
        console.error('fetchPredictRecords failed', err)
        this.betRecords = defaultRecords
      }
    },
    showTicketMessage (msg) {
      if (!msg) return
      this.ticketMessageText = msg
      this.ticketMessageOpen = true
    },
    async onClaimTicket () {
      if (this.isClaimingTicket) return
      if (!this.memberToken) {
        this.showTicketMessage('缺少 token，無法領票')
        return
      }
      this.isClaimingTicket = true
      try {
        const res = await fetch('/api/fifaUserInfo', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ token: this.memberToken })
        }).then(r => r.json())
        if (!res || (res.code !== '0' && res.code !== 0) || !res.data) {
          this.showTicketMessage('取得領票資訊失敗')
          return
        }

        const { user = '', totalCount = 0, count = 0, msg = '' } = res.data
        this.memberAccount = user || this.memberAccount
        this.ticketsClaimed = totalCount
        this.ticketsUsed = Math.max(0, totalCount - count)
        this.showTicketSummary = true
        this.showTicketMessage(msg || '領票資訊已更新')
      } catch (err) {
        console.error('onClaimTicket failed', err)
        this.showTicketMessage('系統忙碌中，請稍後再試')
      } finally {
        this.isClaimingTicket = false
      }
    },
    async onConfirmSelection () {
      if (!this.selectedSliderTeamId) {
        this.showTicketMessage('請先在國旗區選擇國家隊')
        return
      }
      if (this.isTeamDisused(this.selectedSliderTeamId)) {
        this.showTicketMessage('該國家隊已淘汰，無法選擇')
        return
      }
      await this.submitPrediction(this.selectedSliderTeamId)
    },
    async submitPrediction (teamId) {
      if (this.isSubmittingPrediction) return
      if (!this.memberToken) {
        this.showTicketMessage('缺少 token，無法送出預測')
        return
      }
      if (!teamId) {
        this.showTicketMessage('請先選擇國家隊')
        return
      }
      if (this.isTeamDisused(teamId)) {
        this.showTicketMessage('該國家隊已淘汰，無法選擇')
        return
      }

      this.isSubmittingPrediction = true
      try {
        const res = await fetch('/api/fifaPredict', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            token: this.memberToken,
            teamIds: [teamId]
          })
        }).then(r => r.json())

        if (res && (res.code === '0' || res.code === 0) && res.data) {
          const { predictionCount = this.ticketsUsed, count } = res.data
          if (typeof count === 'number') {
            this.ticketsUsed = Math.max(0, this.ticketsClaimed - count)
          } else {
            this.ticketsUsed = predictionCount
          }
          await this.fetchPredictRecords()
          await this.fetchTeamPredictionCount()
          this.updateFlagSliderCounts()
          if (this.selectedSliderTeamId) {
            this.updatePrizePoolByTeam(this.selectedSliderTeamId)
          }
          this.showTicketMessage('預測送出成功')
          return
        }

        const failMsg = (res && typeof res.data === 'string')
          ? res.data
          : '預測送出失敗'
        this.showTicketMessage(failMsg)
      } catch (err) {
        console.error('submitPrediction failed', err)
        this.showTicketMessage('系統忙碌中，請稍後再試')
      } finally {
        this.isSubmittingPrediction = false
      }
    }
  }
}
</script>

<style>
@import '../assets/fifa2026/css/style.css';
</style>



// WEBPACK FOOTER //
// src/components/fifa2026.vue